"use strict";

function throwError(state, props) {
  var partialVisbile = props.partialVisbile,
      partialVisible = props.partialVisible,
      centerMode = props.centerMode,
      ssr = props.ssr,
      responsive = props.responsive;
  if ((partialVisbile || partialVisible) && centerMode) throw new Error("center mode can not be used at the same time with partialVisible");
  if (!responsive) throw ssr ? new Error("ssr mode need to be used in conjunction with responsive prop") : new Error("Responsive prop is needed for deciding the amount of items to show on the screen");
  if (responsive && "object" != typeof responsive) throw new Error("responsive prop must be an object");
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = throwError;